import { Link } from 'react-router-dom';
import ProductSkeleton from "./ProductSkeleton";
import React from "react";

const Product = ({ product, data }) => {
    return (
        !product ? <ProductSkeleton /> :
            <Link to={`/product/${product.name.toLowerCase().replace(/\s+/g, '-')}/`}>
                <div
                    className='grad shadow-2xl w-full h-[420px] rounded-2xl overflow-hidden relative group transform transition-all duration-300 hover:shadow-3xl hover:-translate-y-2'
                >
                    <div className='absolute -top-20 -right-20 w-40 h-40 bg-accent rounded-full opacity-0 group-hover:opacity-10 blur-3xl transition-opacity duration-500' />
                    <div className='absolute -bottom-20 -left-20 w-40 h-40 bg-accent rounded-full opacity-0 group-hover:opacity-10 blur-3xl transition-opacity duration-500' />

                    {product.brand ? (
                        <div
                            className='absolute top-4 left-4 z-20 px-4 py-2 rounded-full text-primary text-[11px]
                            font-extrabold uppercase bg-accent/85 backdrop-blur-md shadow-lg
                            transform transition-all duration-300 group-hover:scale-110 group-hover:shadow-xl'
                        >
                            {product.brand}
                        </div>
                    ) : null}

                    <div className='bg-white w-full h-[240px] relative overflow-hidden flex items-center justify-center'>
                        <img
                            className='w-full h-full object-contain 
                            transform transition-transform duration-500 group-hover:scale-115 p-6'
                            src={product.thumbnail}
                            alt={product.name}
                        />
                        <div className='absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-20 transform -skew-x-12 group-hover:translate-x-full transition-all duration-700' />
                    </div>

                    <div className='pt-5 px-6 pb-6 flex flex-col h-[180px] justify-between relative z-10'>
                        <div className='space-y-2'>
                            <div className='text-xs text-accent capitalize font-semibold tracking-widest opacity-80 group-hover:opacity-100 transition-opacity duration-300'>
                                {product.category.category_name}
                            </div>

                            <h4 className='text-[15px] font-semibold leading-snug mb-2 line-clamp-2 
                            group-hover:text-accent transition-colors duration-300 text-gray-200'>
                                {product.name.substring(0, 50)}...
                            </h4>
                        </div>

                        <div className='flex items-end justify-between gap-3'>
                            <div className='flex flex-col gap-1'>
                                <div className='text-2xl font-bold text-accent'>
                                    ${product.price}
                                </div>
                                {data?.length > 0 && (
                                    <div className="text-xs text-gray-500 font-medium">
                                        ≈ {(product.price * data[0].rate).toLocaleString('ru-RU')} сўм
                                    </div>
                                )}
                            </div>

                            <div className='opacity-0 group-hover:opacity-100 transform translate-x-3 group-hover:translate-x-0 transition-all duration-300'>
                                <svg className="w-6 h-6 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <div className='absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-accent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500' />
                </div>
            </Link>
    );
};

export default Product;
